import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import InsurancesListView from './Insurances';
import InsuranceDetailView from './InsuranceDetail';

const InsurancesView = () => (
  <Routes>
    <Route path="list" element={<InsurancesListView />} />
    <Route path="list/:policyId/*" element={<InsuranceDetailView />} />
    <Route path="list/:policyId" element={<InsuranceDetailView />} />
    <Route index element={<Navigate to="list" replace />} />
  </Routes>
);

export default InsurancesView;
